import { o_global } from "@gr-common/head/namespaces";

/**
 *
 *
 *
 *
 *
 */
export function returnWithCache<K, T>(cache: Map<K, T>, key: K, data: NoInfer<T>): T {
  cache.set(key, data);
  return data;
}

/**
 *
 *
 *
 *
 */
export function jsonParseOrUse(value: string): unknown {
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
}

/**
 *
 */
export const loggerScope = o_global.debug.scope("assets.attribute-parser");

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function isValueType(
  name: string,
  values: [current: unknown, previous: unknown],
  explicit: readonly string[] | ParameterTypeChecker | undefined,
  checker: (value: unknown) => boolean,
): boolean {
  if (typeof explicit === "function") {
    return explicit(name, values);
  }

  if (explicit !== undefined) {
    return explicit.some((p) => p === name || p.toLowerCase() === name);
  }

  return values.some(checker);
}

/**
 *
 *
 *
 */
export function isPrimitive(value: unknown): boolean {
  return typeof value === "string" || typeof value === "number" || typeof value === "boolean";
}

/**
 *
 *
 *
 */
export function isArray(value: unknown): boolean {
  return Array.isArray(value);
}

/**
 *
 *
 */
export type ParameterTypeChecker = (
  name: string,
  values: [current: unknown, previous: unknown],
) => boolean;

/**
 *
 */
export type ParameterMergeOptions = {
  /**
 *
 *
 *
 *
 *
 */
  primitiveAttributes?: readonly string[] | ParameterTypeChecker;
  /**
 *
 *
 *
 *
 *
 */
  arrayAttributes?: readonly string[] | ParameterTypeChecker;
};

export const MERGE_OPTIONS_KEYS = [
  "primitiveAttributes",
  "arrayAttributes",
] as const satisfies (keyof ParameterMergeOptions)[];

/**
 *
 *
 *
 *
 *
 *
 */
export function mergeParameterValues<T>(
  name: string,
  values: T[],
  options: ParameterMergeOptions,
): T {
  const res = values.reduce((acc, value) => {
    if (acc === undefined) {
      return value;
    }

    if (isValueType(name, [value, acc], options[MERGE_OPTIONS_KEYS[0]], isPrimitive)) {
      return value ?? acc;
    }

    if (isValueType(name, [value, acc], options[MERGE_OPTIONS_KEYS[1]], isArray)) {
      return [...(acc as unknown[]), ...((value ?? []) as unknown[])] as T;
    }

    return { ...acc, ...value };
  });

  return res;
}
